import React,{useState,useEffect,useRef} from "react";

  import { useRouteMatch} from "react-router-dom";
import { useHistory,} from "react-router-dom";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useSchemaHistory } from "../CreateApp/useSchemaHistory";

import {X,Plus } from 'lucide-react';

import Loading from "../../Loading/Loading"; 

import loadable from '@loadable/component';

// npm i @loadable/component 
import imageMap from "./ImageMap"; 
import PageDropDownMenuCard from "../CreateApp/Cards/PageDropDownMenuCard";
import AppMenuCard from "../CreateApp/Cards/AppMenuCard";
import UIWebBlockRenderer from "./UIWebBlockRenderer";
import ListUISettingsLoading from "./DesignElements/ListUISettingsLoading";

import { sectionTheme1InfoCardObject } from "./Templates/Template1/ExportSectionObjects";
import WebUISettings from "./DesignElements/WebUISettings";
import CourseCardBuilder from "./CourseCard/CourseCardBuilder";
import LeadFormBuilder from "./LeadForms/LeadFormBuilder";
import ItemCardAppDesign from "../CreateApp/Cards/ItemCardAppDesign";
import PlayerCardBuilder from "./PlayerPage/PlayerCardBuilder";
import CoursePageCardBuilder from "./CoursePageDesign/CoursePageCardBuilder";
import MockTestBuilder from "./TestPage/Mocks/MockTestBuilder";
import { createNewPageCMRest, createNewSectionCMRest } from "../../../store/actions/CreateApp/pagesRestAPIs";
import CustomCanvasConfetti from "../../UI/Confetti";
import CreateNewWebPage from "./CreateNewWebPage";
import VariationSectionTemplates from "./DesignElements/VariationSectionTemplates";
import AppDashboard from "./DashboardPage/AppDashboard";
import DashboardBuilder from "./DashboardPage/DashboardBuilder";
  let lazyLoad =   <Loading/>;
  const Navber = loadable(() => import("../../../Navbar/UserMenu"), {
    fallback: lazyLoad  });
  
    
  
 const WebsiteSettings = ()=>{
      const {url}=useRouteMatch();
      const pathname = window.location.pathname;

         const [snackbarVisible, setSnackbarVisible] = useState(false);
         const [snackbarColor, setSnackbarColor] = useState("#958FDA");
         const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
         const [activeCardDesign, setActiveCardDesign] =useState(false);
         const [activeCardScreens, setActiveCardScreens] =useState(false);
         const [activeCardElements, setActiveCardElements] =useState(true); 
         const [activeCardSettings, setActiveCardSettings] =useState(false);   
         const [fixMenuAppRight, closeFixMenuAppRight] =useState(false);   
          const [openAppDesignPopUpInn,setopenAppDesignPopUpInn]  = useState(false);
        
         const rightFixClose =fixMenuAppRight?"visible":"hidden";
         const rightFixOpen =fixMenuAppRight?"hidden":"visible";
         const fixMenuAppRightHide={width:"70px",visibility:rightFixClose,height:"80px"}
         const fixMenuAppRightShow={width:"70px",visibility:rightFixOpen}
       
         const [designContent, openDesignContent] =useState(false);      
           const mainMenuStatus = useSelector((state)=>state?.app?.mainMenuStatus);
         const [deviceWidth,setDeviceWidth] = useState(false);
         const bottomDivRef = useRef(null);
         
         const bottomDivBoxRef = useRef(null);
         const bodyWidthForMobile =useRef(null)
         
         const [isVisible, setIsVisible] = useState(false);
       
         const [divHeight, setDivHeight] = useState(0);;
       
         const [currentItemIndex, setCurrentItemIndex] = useState(0);
        const [cardEditor,setCardEditor] = useState("");
        const [currentPage,setCurrentPage] = useState({});
       const [dropFlag,setDropFlag] = useState(1);
              const [closeVariationPopUp, setCloseVariationPopUp] = useState(false);
  
                    const [fireConfetti, setFireConfetti] = useState(false);
         // add Draggable cards per theme 
         const DragCards=[{theme:"Theme1", Cards: [
                                            { card: "Card1", src: "Theme1InfoCard1.png" },
                                            { card: "Card2", src: "SectionCard2.png" },
                                            { card: "Card3", src: "Theme1Card3.png" },
                                            { card: "Card4", src: "Theme1Card4.png" },
                                            { card: "Card5", src: "Theme1Card5.png" },
                                           { card: "Card6", src: "Theme1Card6.png" },
                                           { card: "Section1", src: "Theme1SectionCard1.png" },
                                           
                                                  ],
                           },{},{}]


   
        useEffect(() => {
       
           if (bodyWidthForMobile.current) {
             let offsetWidth = bodyWidthForMobile?.current?.offsetWidth;
               setDeviceWidth(offsetWidth)
           }
           setDivHeight(bottomDivBoxRef?.current?.offsetHeight);
           const observer = new IntersectionObserver(
             ([entry]) => {
               if (entry.isIntersecting) {
                 setIsVisible(true); // Set state when the div appears
               } else {
                 setIsVisible(false); // Reset state if it goes out of view
               }
             },
             {
               root: null, // Observe within the viewport
               threshold: 1.0, // Trigger only when fully visible (at the bottom of the viewport)
             }
           );
       
           if (bottomDivRef.current) {
             observer.observe(bottomDivRef.current);
           }
       
           return () => {
             if (bottomDivRef.current) {
               observer.unobserve(bottomDivRef.current);
             }
           };
         }, [deviceWidth])
       const showSnackbar = () => {
         setSnackbarVisible(true);
       };
      
       const hideSnackbar = () => {
         setSnackbarVisible(false);
       };
       const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
        {
          
          dispatch({type: "CURSOR",payload:true  });
 
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }
        
     ;
         const [loader , setLoader] =useState({status:false});
       const [animate, setAnimate] = useState(false); 
       const [openPopUp, setOpenPopUp] = useState(""); 
       
       useEffect(() => {
               
       
         // Trigger the animation after a delay (e.g., 500ms)
         const timer = setTimeout(() => {
          setAnimate(true);  
        }, 100);
       
         return () => clearTimeout(timer); // Cleanup on unmount
       }, []);
       
       
  const history = useHistory();
      const dispatch = useDispatch();
 const [screenBackground , setScreenBackground]=useState("rgba(144, 202, 249,0.2)")
   const [scrollItems, setScrollItems] = useState("Grid");// dark /faint
                        const [columnsList, setColumnsList] = useState(3);// black / white
                        const [fontFamily, setFontFamily] = useState({name:"OpenSans-Regular",
  fontFamily:"OpenSansRegular , sans-serif"
 });// black / white
                       const [fontWeight, setFontWeight] = useState("700");// black / white
                       const [layoutSettings, setLayoutSettings] = useState({});// black / white
                        const [cards, setCards] = useState([]);// black / white
                      const [currentContentIndex, setCurrentContentIndex] = useState(1);
                      const [hideReduUnDo, setHideReduUnDo] = useState(false);
                      
                       const [iWidth, setiWidth] = useState("90%");
                        const [iHeight, setiHeight] = useState(80);
                        const [titleFontSize, setTitleFontSize] = useState(14);
                        const [subTitleFontSize, setSubTitleFontSize] = useState(10);
                        const [titleFontColor, setTitleFontColor] = useState({});
                        const [subTitleFontColor, setSubTitleFontColor] = useState({});
                        
                        const [titleFontWeight, setTitleFontWeight] = useState(600);
                        const [subTitleFontWeight, setSubTitleFontWeight] = useState(500);
                        
                       const [borderRadius, setBorderRadius] = useState(100);
                       const [marginLeft, setmarginLeft] = useState(10);
                      const [marginTop, setmarginTop] = useState(10);
                      const [marginBottom, setmarginBottom] = useState(10);
                       const [imarginLeft, setimarginLeft] = useState(18);
                      const [imarginTop, setimarginTop] = useState(5);
                      const [aspectRatio, setAspectRatio] = useState(4/3);
                       const [showTitle, setShowTitle] = useState(true);
                       const [showSubTitle, setShowSubTitle] = useState(false);
                       const [textAlignment, setTextAlignment] = useState("center");
                       const [textPosition, setTextPosition] = useState("onImage");
                       const [applyOverlay, setApplyOverlay] = useState(false);
                       const [overlayTitleFontColor, setOverlayTitleFontColor] = useState("rgba(219, 236, 229,1)");
                       const [overlayBG, setOverlayBG] = useState("rgba(144, 202, 249,0.15)");
                       const [absoluteHorizontal, setAbsoluteHorizontal] = useState("left");
                       const [absoluteHorizontalMargin, setAbsoluteHorizontalMargin] = useState(0);
                       const [absoluteVertical, setAbsoluteVertical] = useState("top");
                       const [absoluteVerticalMargin, setAbsoluteVerticalMargin] = useState(10);
                       const [itemVisibility, setItemVisibility,] = useState("Both");
                        
                       const [itemBackground, setItemBackground] = useState("");
                       const [closePagePopUp, setClosePagePopUp] = useState(false);
                     
 const token = useSelector((state)=>state?.course?.course?.token);
 const currentToken = useSelector((state)=>state?.user?.user?.token);
const courseData = useSelector((state)=>state?.course?.course);
const AppToken = useSelector((state)=>state?.app?.RecentAppToken);
 const appId = useSelector((state)=>state?.app?.app?.ID);
const AppDesign = useSelector((state)=>state?.app?.appDesign);

const user_email = useSelector((state)=>state?.user?.user?.user_email);
const user = useSelector((state)=>state?.user?.user);

 const [dynamicId, setDynamicId] = useState("");
const [dynamicIdChange, setDynamicIdChange] = useState(true);
const [currentContentObject, setCurrentContentObject] = useState({});
const pageArrLoads=[{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{}];
   const [pageArrLoading, setPageArrLoading] = useState(pageArrLoads);
   const [pageArr, setPageArr] = useState([]);
     
 





       const [reloadItems, setReloadItems] = useState(true);
                // const imagesList1 = [
                //    { id: 1,hideImage: false, title: "Clear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://plus.unsplash.com/premium_photo-1747220093883-a5a198dea23a?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwcm9maWxlLXBhZ2V8NXx8fGVufDB8fHx8fA%3D%3D" },
                //  { id: 2,hideImage: false, title: "Clear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://plus.unsplash.com/premium_photo-1688891564708-9b2247085923?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
                //   { id: 3,hideImage: false, title: "Clear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://plus.unsplash.com/premium_photo-1689551670902-19b441a6afde?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
                // { id: 4,hideImage: false, title: "Clear Your DoubtsClear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://plus.unsplash.com/premium_photo-1664541336896-b3d5f7dec9a3?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
                //              { id: 5,hideImage: false, title: "Clear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://plus.unsplash.com/premium_photo-1689530775582-83b8abdb5020?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
                //   { id: 6,hideImage: false, title: "Clear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?q=80&w=1974&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" },
                // ];
                //     const imagesList2 = [
                //     { id: 1,hideImage: false, title: "Clear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://shop.classmock.com/wp-content/uploads/2024/10/139.png" },
                //  { id: 2,hideImage: false, title: "Clear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://shop.classmock.com/wp-content/uploads/2024/10/8.png" },
                //   { id: 3,hideImage: false, title: "Clear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://shop.classmock.com/wp-content/uploads/2024/10/13.png" },
                // { id: 4,hideImage: false, title: "Clear Your DoubtsClear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://shop.classmock.com/wp-content/uploads/2024/10/11.png" },
                //  ];
                    
                //  const imagesList3 = [
                //     { id: 1,hideImage: false, title: "Clear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://shop.classmock.com/wp-content/uploads/2025/05/img1.png" },
                //  { id: 2,hideImage: false, title: "Clear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://shop.classmock.com/wp-content/uploads/2025/05/Screenshot-2025-05-28-013542.png" },
                //   { id: 3,hideImage: false, title: "Clear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://shop.classmock.com/wp-content/uploads/2025/05/Screenshot-2025-05-28-013732.png" },
                // { id: 4,hideImage: false, title: "Clear Your DoubtsClear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://shop.classmock.com/wp-content/uploads/2025/05/Screenshot-2025-05-28-013755.png" },
                // // { id: 5, title: "Clear Your DoubtsClear Your Doubts",subtitle: "Join Live Classes With Customized Schedule", image: "https://shop.classmock.com/wp-content/uploads/2025/05/Screenshot-2025-05-28-013742.png" },
                //  ];



  const [selectedItemIndex, setSelectedItemIndex] = useState(null); 
const itemArrLoads=[{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{},{}];
   const [itemArrLoading, setItemArrLoading] = useState(itemArrLoads);
       const flattenedDataLoading = itemArrLoading!=[]?Object.values(itemArrLoading):[];

const generateUID = (val = "") => {
 
  return (val); // encode to base64
};
const decodeUID = (encodedStr) => {
  try {
    const decoded = atob(encodedStr); // decode from base64
    
    return decoded;
  } catch (err) {
    console.error("Invalid UID format");
    return null;
  }
};
  const initialSchema =[]

const [itemArr, setItemArr] = useState(initialSchema);
 
const {
    currentSchema,
    updateSchema,
    undo,
    redo,
    reset,
    canUndo,
    canRedo,clearHistoryBeforeCurrent,currentIndex
  } = useSchemaHistory(itemArr);
  

const[item, setItem]= useState({});

     useEffect(() => {
    const index = currentSchema?.findIndex(item => item?.id === currentContentObject?.id);
 
       // Trigger the animation after a delay (e.g., 500ms)
     
       const timer = setTimeout(() => {
        setAnimate(true);    
      }, 0);
    
       return () => clearTimeout(timer); // Cleanup on unmount
     }, [currentIndex]);
 function generateTimestamp() {
        return Math.floor(Date.now() / 1000);
      }
 useEffect(()=>{fireGetAllPagesByAppId()},[closePagePopUp ])
         
      const fireGetAllPagesByAppId=()=>{
        setItemArrLoading([{},{},{},{}])
         setLoader({status:true});
          
           const apiData = dispatch(createNewPageCMRest({pageType:"page",
                   postParent:appId,userEmail:user_email?user_email:"",
                   currentToken:currentToken?currentToken:"",visibility:"public",status:"active",menuOrder:0,isPrivate:false,
                   editType:"getAll",appToken:AppToken,appId:appId}
                   ));
           /* get response as Promise   */
           apiData.then(response => {
             if(response){   
               if(response?.pages){
                 setPageArrLoading([])
          setPageArr(response?.pages)
          setCurrentPage(response?.pages[0])
            }else{
             setResponseMessage("Something Went Wrong...");
               
             setSnackbarColor("#958FDA");
          
              
         setLoader({status:false});
         
         setSnackbarVisible(true);
         setTimeout(()=>{
           
           setSnackbarVisible(false);
          
            
         },3000)
            }
               
            
            if(response?.logout){
            
             setResponseMessage("You are Logged Out!!!");
               
             setSnackbarColor("#958FDA");
          
              
         setLoader({status:false});
         
         setSnackbarVisible(true);
         setTimeout(()=>{
           
           setSnackbarVisible(false);
          
            
         },3000)
             setTimeout(()=>{
               dispatch({type:"LOGOUT"});
         
             },3000)
             
           }
         /* resetting Login input Fields */
         
             }else{
               setResponseMessage("Something Went Wrong...");
               
               setSnackbarColor("#958FDA");
            
                
           setLoader({status:false});
           
           setSnackbarVisible(true);
           setTimeout(()=>{
             
             setSnackbarVisible(false);
            
              
           },3000)    }
         
           }).catch(error => {
          
             //popup of error Info
             setResponseMessage("Something Went Wrong...");
               
             setSnackbarColor("#958FDA");
          
              
         setLoader({status:false});
         
         setSnackbarVisible(true);
         setTimeout(()=>{
           
           setSnackbarVisible(false);
          
            
         },3000)
             console.error(error);
           });
          
           }


       useEffect(()=>{fireGetAllSectionsByPageId()},[currentPage?.id])    
      const fireGetAllSectionsByPageId=()=>{
        setItemArrLoading([{},{},{},{}])
          setItemArr([])

          updateSchema([])
         setLoader({status:true});
          
           const apiData = dispatch(createNewSectionCMRest({
                   postParent:currentPage?.id,userEmail:user_email?user_email:"",
                   currentToken:currentToken?currentToken:"",visibility:"public",status:"active",isPrivate:false,
                   editType:"getAll",appToken:AppToken,appId:appId}
                   ));
           /* get response as Promise   */
           apiData.then(response => {
             if(response){   
               if(response?.sections){
                 setItemArrLoading([])
                 if(response?.sections?.length){
                  setItemArr(response?.sections)

          updateSchema(response?.sections)
                 }else{
                  setItemArr([])

          updateSchema([])
                 }
          
            }else{
             setResponseMessage("Something Went Wrong...");
               
             setSnackbarColor("#958FDA");
          
              
         setLoader({status:false});
         
         setSnackbarVisible(true);
         setTimeout(()=>{
           
           setSnackbarVisible(false);
          
            
         },3000)
            }
               
            
            if(response?.logout){
            
             setResponseMessage("You are Logged Out!!!");
               
             setSnackbarColor("#958FDA");
          
              
         setLoader({status:false});
         
         setSnackbarVisible(true);
         setTimeout(()=>{
           
           setSnackbarVisible(false);
          
            
         },3000)
             setTimeout(()=>{
               dispatch({type:"LOGOUT"});
         
             },3000)
             
           }
         /* resetting Login input Fields */
         
             }else{
               setResponseMessage("Something Went Wrong...");
               
               setSnackbarColor("#958FDA");
            
                
           setLoader({status:false});
           
           setSnackbarVisible(true);
           setTimeout(()=>{
             
             setSnackbarVisible(false);
            
              
           },3000)    }
         
           }).catch(error => {
          
             //popup of error Info
             setResponseMessage("Something Went Wrong...");
               
             setSnackbarColor("#958FDA");
          
              
         setLoader({status:false});
         
         setSnackbarVisible(true);
         setTimeout(()=>{
           
           setSnackbarVisible(false);
          
            
         },3000)
             console.error(error);
           });
          
           }
  const handleCreateNewPageCMRest=(pageName)=>{
     
     
     
     setLoader({status:true});
       const apiData = dispatch(createNewPageCMRest({pageType:"page",pageName:pageName,pageRouteSlug:"",metaTitle:"",
        metaDescription:"",featuredImage:"",layoutJson:"",seoJson:"",
                   postParent:appId,userEmail:user_email?user_email:"",
                   currentToken:currentToken?currentToken:"",visibility:"public",status:"active",menuOrder:0,isPrivate:false,
                   editType:"create",appToken:AppToken,appId:appId}
                   ));  
       /* get response as Promise   */
       apiData.then(response => {
         if(response){  console.log(response)   
           if(response?.page){
           
         setResponseMessage(response?.message);
         setSnackbarColor("rgba(144, 202, 249,1)");
      
       setFireConfetti(true) 
       setTimeout(()=>{
            
       setFireConfetti(false) 
         },100)
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
     },1000)
        }else{
         setResponseMessage("Something Went Wrong...");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
        }
           
        
        if(response?.logout){
        
         setResponseMessage("You are Logged Out!!!");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
         setTimeout(()=>{
           dispatch({type:"LOGOUT"});
     
         },3000)
         
       }
     /* resetting Login input Fields */
     
         }else{
           setResponseMessage("Something Went Wrong...");
           
           setSnackbarColor("#958FDA");
        
            
       setLoader({status:false});
       
       setSnackbarVisible(true);
       setTimeout(()=>{
         
         setSnackbarVisible(false);
        
          
       },3000)    }
     
       }).catch(error => {
      
         //popup of error Info
         setResponseMessage("Something Went Wrong...");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
         console.error(error);
       });
      
       }

  const handleCreateNewSectionCMRest=(sectionSchema,dropFlagk,dropIndex ,reordered)=>{
      if(dropFlagk>1){return;}
  
     setLoader({status:true});
       const apiData = dispatch(createNewSectionCMRest({sectionType:"page",blockType:"",myKey:"",schemaVersion:"",sectionSchema:JSON.stringify(sectionSchema),
        layoutJson:"",typographyJson:"",mediaRefsJson:"",animationJson:"",customDataJson:"",
                   postParent:currentPage?.id,userEmail:user_email?user_email:"",
                   currentToken:currentToken?currentToken:"",visibility:"public",status:"active",menuOrder:dropIndex,isPrivate:false,
                   editType:"create",appToken:AppToken,appId:appId}
                   ));  
       /* get response as Promise   */
       apiData.then(response => {
         if(response){    
           if(response?.section){
          
setItemArr(prev => {
  let replacedStatus = false;

  const updatedArr = prev.map(item => {
    if (!replacedStatus && !item?.dbId) {
      replacedStatus = true;
      return { ...item, dbId: parseInt(response?.section?.id) };
    }
    return item;
  });

  // Call your schema update here
  updateSchema(updatedArr);

  return updatedArr;
});
            let replaced = false;
         reordered = reordered.map(item => {
        if (!replaced && item?.id === undefined) {
            replaced = true;
            return { ...item, id: response?.section?.id };
        }
        return item;
    }); 


    handleReorderSectionsCMRest(reordered)
          
    

         setResponseMessage(response?.message);
         setSnackbarColor("rgba(144, 202, 249,1)");
      
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
     },1000)
        }else{
         setResponseMessage("Something Went Wrong...");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
        }
           
        
        if(response?.logout){
        
         setResponseMessage("You are Logged Out!!!");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
         setTimeout(()=>{
           dispatch({type:"LOGOUT"});
     
         },3000)
         
       }
     /* resetting Login input Fields */
     
         }else{
           setResponseMessage("Something Went Wrong...");
           
           setSnackbarColor("#958FDA");
        
            
       setLoader({status:false});
       
       setSnackbarVisible(true);
       setTimeout(()=>{
         
         setSnackbarVisible(false);
        
          
       },3000)    }
     
       }).catch(error => {
      
         //popup of error Info
         setResponseMessage("Something Went Wrong...");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
         console.error(error);
       });
      
       }

       
  const handleUpdateSectionSchemaCMRest=(sectionId,sectionSchema)=>{
     setLoader({status:true});
       const apiData = dispatch(createNewSectionCMRest({field:"section_schema",value:JSON.stringify(sectionSchema),
        sectionId:sectionId,
                   postParent:currentPage?.id,userEmail:user_email?user_email:"",
                   currentToken:currentToken?currentToken:"",visibility:"public",status:"active",isPrivate:false,
                   editType:"updateField",appToken:AppToken,appId:appId}
                   ));  
       /* get response as Promise   */
       apiData.then(response => {
         if(response){    
         
           
        
        if(response?.logout){
        
         setResponseMessage("You are Logged Out!!!");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
         setTimeout(()=>{
           dispatch({type:"LOGOUT"});
     
         },3000)
         
       }
     /* resetting Login input Fields */
     
         }else{
           setResponseMessage("Something Went Wrong...");
           
           setSnackbarColor("#958FDA");
        
            
       setLoader({status:false});
       
       setSnackbarVisible(true);
       setTimeout(()=>{
         
         setSnackbarVisible(false);
        
          
       },3000)    }
     
       }).catch(error => {
      
         //popup of error Info
         setResponseMessage("Something Went Wrong...");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
         console.error(error);
       });
      
       }
  const handleDeleteSectionCMRest=(sectionId,reordered)=>{
      
     setLoader({status:true});
       const apiData = dispatch(createNewSectionCMRest({sectionId:sectionId,
                   postParent:currentPage?.id,userEmail:user_email?user_email:"",
                   currentToken:currentToken?currentToken:"",
                   editType:"delete",appToken:AppToken,appId:appId}
                   ));  
       /* get response as Promise   */
       apiData.then(response => {
         if(response){    
           if(response?.section){
       


    handleReorderSectionsCMRest(reordered)
          
    

         setResponseMessage(response?.message);
         setSnackbarColor("rgba(144, 202, 249,1)");
      
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
     },1000)
        }else{
         setResponseMessage("Something Went Wrong...");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
        }
           
        
        if(response?.logout){
        
         setResponseMessage("You are Logged Out!!!");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
         setTimeout(()=>{
           dispatch({type:"LOGOUT"});
     
         },3000)
         
       }
     /* resetting Login input Fields */
     
         }else{
           setResponseMessage("Something Went Wrong...");
           
           setSnackbarColor("#958FDA");
        
            
       setLoader({status:false});
       
       setSnackbarVisible(true);
       setTimeout(()=>{
         
         setSnackbarVisible(false);
        
          
       },3000)    }
     
       }).catch(error => {
      
         //popup of error Info
         setResponseMessage("Something Went Wrong...");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
         console.error(error);
       });
      
       }
  const handleReorderSectionsCMRest=(reordered)=>{
      
     setLoader({status:true});
       const apiData = dispatch(createNewSectionCMRest({menuOrderArr:JSON.stringify(reordered),
                   postParent:currentPage?.id,userEmail:user_email?user_email:"",
                   currentToken:currentToken?currentToken:"",visibility:"public",status:"active",isPrivate:false,
                   editType:"reorder",appToken:AppToken,appId:appId}
                   ));  
       /* get response as Promise   */
       apiData.then(response => {
         if(response){    
       
        
        if(response?.logout){
        
         setResponseMessage("You are Logged Out!!!");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
         setTimeout(()=>{
           dispatch({type:"LOGOUT"});
     
         },3000)
         
       }
     /* resetting Login input Fields */
     
         }else{
           setResponseMessage("Something Went Wrong...");
           
           setSnackbarColor("#958FDA");
        
            
       setLoader({status:false});
       
       setSnackbarVisible(true);
       setTimeout(()=>{
         
         setSnackbarVisible(false);
        
          
       },3000)    }
     
       }).catch(error => {
      
         //popup of error Info
         setResponseMessage("Something Went Wrong...");
           
         setSnackbarColor("#958FDA");
      
          
     setLoader({status:false});
     
     setSnackbarVisible(true);
     setTimeout(()=>{
       
       setSnackbarVisible(false);
      
        
     },3000)
         console.error(error);
       });
      
       }
 const flattenedPageData = pageArr!=[]?Object.values(pageArr):'';

  const flattenedPageDataLoading = pageArrLoading!=[]?Object.values(pageArrLoading):'';

  
  
const [draggedIndex, setDraggedIndex] = useState('');
const [hoveredDropZone, setHoveredDropZone] = useState(null); // Track hovered drop zone

const handleDragStart = (e, index) => {
  
  e.dataTransfer.effectAllowed = 'move';
  e.dataTransfer.setData("dragIndex", index);
  
};
const extractElementType = (str) => {
  const match = str?.match(/^.*?-(.*?)-.*$/);
  return match ? match[1] : null;
};
useEffect(() => {

   setDynamicId(itemArr[0]?.myKey) 

   setCurrentContentObject(itemArr[0]) 
   //- states take delays so use setTimeOut
   setDynamicIdChange(false);setItemArrLoading(itemArrLoads)
 const timer= setTimeout(()=>{ setDynamicIdChange(true);setItemArrLoading([]) },200)
  // clear timer
   return () => clearTimeout(timer);
}, []);

const updateItemBackground=(val)=>{
   // ;setReloadList2((prev) => ({ ...prev, [dynamicId]: false }));setTimeout(()=>{setReloadList2((prev) => ({ ...prev, [dynamicId]: true }));},0)
setItemArr((prev) => {
    const updatedItems = prev.map(item => {
      if (item.myKey === dynamicId) { return {...item,  itemBackground:val }; } return item;
    });setItemBackground(prev => ({ ...prev, [dynamicId]: val  }));return updatedItems;
       });
   }
 const updateImagesData=(val)=>{ console.log("item"); 
 setItemArr((prev) => {
  // these keys are used when duplicating items
    const updatedItems = prev.map(item => {  if (dynamicId==item?.contents[currentContentIndex-1]?.myKey) { console.log("item"); 
       
       return { ...item,
      contents: item?.contents.map((content, index) =>
    index === currentContentIndex
      ? { ...content, itemCards:{...content?.itemCards,cards:val}
      }
      : content
  ),
    };
    
  }
  if (dynamicId==item?.contents[currentContentIndex-1]?.myKey) {   console.log("item");  console.log(item); }
  return item;});
        
 return updatedItems;; });
      }

const moveItemUp = (obj) => {
  setItemArr((prev) => {
    const updatedItems = [...prev];
   const index = updatedItems.findIndex(item => item?.id === obj?.id);

if (index > 0) {
  // Destructuring swap
  [updatedItems[index - 1], updatedItems[index]] = [updatedItems[index], updatedItems[index - 1]];
}

    clearHistoryBeforeCurrent()
  // setting Current Schema

  let finalSchema;

  finalSchema = updatedItems
    .map((item, index) => ({ ...item, _originalIndex: index }))
    .reverse()
    .filter((item, index, self) =>
      self.findIndex(i => i.id === item.id) === index
    )
    .reverse()
    .map(({ _originalIndex, ...item }) => item);

   updateSchema(finalSchema);
     const reordered = finalSchema.map((item, index) => ({
    id: item?.dbId,
    menuOrder: index+1
}));


    handleReorderSectionsCMRest(reordered)
   return finalSchema;
  
  });
  setReloadItems(false);setTimeout(()=>{ setReloadItems(true);},0)
};
const moveItemDown = (obj) => {
  setItemArr((prev) => {
    const updatedItems = [...prev];
    const index = updatedItems.findIndex(item => item?.id === obj?.id);

    if (index !== -1 && index < updatedItems.length - 1) {
      // Swap with the item below
      const temp = updatedItems[index + 1];
      updatedItems[index + 1] = updatedItems[index];
      updatedItems[index] = temp;
    }

   
let finalSchema;

  finalSchema = updatedItems
    .map((item, index) => ({ ...item, _originalIndex: index }))
    .reverse()
    .filter((item, index, self) =>
      self.findIndex(i => i.id === item.id) === index
    )
    .reverse()
    .map(({ _originalIndex, ...item }) => item);

   updateSchema(finalSchema);
    const reordered = finalSchema.map((item, index) => ({
    id: item?.dbId,
    menuOrder: index+1
}));


    handleReorderSectionsCMRest(reordered)
          
   return finalSchema;
  });
};
function duplicateItemVal(originalItem) {
  const timestamp = Date.now();

  const duplicatedItem = {
    ...structuredClone(originalItem), // deep clone
    id: timestamp,
    myKey: originalItem?.myKey + generateTimestamp(),
         // updating Contents Keys
      contents: originalItem?.contents?.map((content, index) =>
    index === index
      ? { ...content, myKey:content?.myKey+generateTimestamp() + 2,
      }
      : content) || [],
  };

  return duplicatedItem;
}
const duplicateItem = (obj) => {
  
  setItemArr((prev) => {
    const updatedItems = [...prev];
    const index = updatedItems?.findIndex(item => item?.myKey === obj?.myKey);

    if (index !== -1) {
    // if(true){
      const originalItem = updatedItems[index];
      const duplicatedItem = duplicateItemVal(originalItem)

      // Insert the duplicated item right after the original
      updatedItems?.splice(index + 1, 0, duplicatedItem);

  
      // do this for all state key updates 
      duplicateItemKey(duplicatedItem,duplicatedItem?.myKey)

    
    // this code is for reloading status for settings component
   
  // console.log(updatedItems)
   updateSchema(updatedItems);
   const reordered = updatedItems.map((item, index) => ({
    id: item?.dbId,
    menuOrder: index+1
}));
  handleCreateNewSectionCMRest(duplicatedItem,1,index + 1,reordered );


    
  // setting Current Schema
      
    }
    return updatedItems;
  });
  
};
const duplicateContentsItem = (obj) => {
  setItemArr((prev) => {
    const updatedItems = prev.map((item, indexItem) => {


         const index = item?.contents?.findIndex?.(c => c.id === obj.id); // find by id or any unique identifier
    //   
    if (true) {
        
      const fullKey = obj.myKey; // e.g. "id-list1-layout1-element3"
      const parentKey = fullKey?.split("-element")[0]; // "id-list1-layout1"

      const parentContentIndex = item?.contents?.findIndex?.(
        (c) => c.myKey === parentKey
      );

      if (parentContentIndex !== -1) {
        const parentContent = item.contents[parentContentIndex];

        const existingInnerBlocks = parentContent.innerBlocks || [];

        
        // ✅ Step 1: Generate new innerBlock key (and use for duplicate too)
        const nextElementNumber = existingInnerBlocks.length + 1;
        const newMyKey = `${parentKey}-element${nextElementNumber}`;
  
        const originalContent = item.contents[index];

        // Deep clone and regenerate keys for duplicated innerBlocks
        const duplicatedInnerBlocks = originalContent.innerBlocks?.map((block, i) => ({
          ...block,
          myKey:  newMyKey,
        })) || [];

        const duplicatedContent = {
          ...originalContent,
          id: generateTimestamp() + generateUID(),
          innerBlocks: duplicatedInnerBlocks,
          myKey: newMyKey,
          // contentNo will be set in map below
        };
//  console.log(duplicatedContent)
        // ✅ Step 2: Create new inner block
         const newInnerBlock = {
          myKey: newMyKey,
          blockType: "element",
          id: generateTimestamp() + generateUID(),
        };

        // ✅ Step 3: Update original content with new innerBlock
        const updatedInnerBlocks = [...existingInnerBlocks, newInnerBlock];
// console.log(updatedInnerBlocks)
        const updatedParentContent = {
          ...parentContent,
          innerBlocks: updatedInnerBlocks,
        };

        
        // ✅ Step 4: Create duplicated content with same key as innerBlock
        
        // console.log(updatedParentContent)
      
        // Insert duplicate just after the original
        const newContents = [...item.contents];
        
         newContents[parentContentIndex] = updatedParentContent;
        newContents.splice(index + 1, 0, duplicatedContent);

        // Reassign contentNo (1-based) for all
        const reorderedContents = newContents.map((content, idx) => ({
          ...content,
          contentNo: idx + 1,
        }));

        return {
          ...item,
          contents: reorderedContents,
        }; }
      }

      return item;
    });

    // console.log(updatedItems);
    updateSchema(updatedItems);
    return updatedItems;
  });
};







const deleteItem = (obj) => {
  setItemArr((prev) => {
    // Remove the item by filtering
    const updatedItems = prev.filter(item => item?.id !== obj?.id);

    // Optional: re-number items
    const reorderedItems = updatedItems.map((item, index) => ({
      ...item,
      no: index + 1,
    }));

    // Update reloadList to reflect current state
    

    // Clear dynamicId if deleted item was focused
    if (obj?.id === item?.id) {
      setDynamicId(null);
      
    }

   updateSchema(reorderedItems);
    const reordered = reorderedItems.map((item, index) => ({
    id: item?.dbId,
    menuOrder: index+1
}));
   handleDeleteSectionCMRest(obj?.dbId,reordered);
    return reorderedItems;
  
  });
};

const duplicateItemKey=(item,key)=>{
 // this code is for adding new dynamic id to column array, 
   setColumnsList(prev => ({
      ...prev,
      [key]:item?.contents[currentContentIndex-1]?.columns
    }));


    setScrollItems(prev => ({
      ...prev,
      [key]:item?.contents[currentContentIndex-1]?.scrollItems
    }));
    setTitleFontSize(prev => ({
      ...prev,
      [key]:item?.contents[currentContentIndex-1]?.titleFontSize
    }));
     setSubTitleFontSize(prev => ({
      ...prev,
      [key]:item?.contents[currentContentIndex-1]?.subTitleFontSize
    })); setTitleFontColor(prev => ({
      ...prev,
      [key]:item?.contents[currentContentIndex-1]?.titleFontColor
    }));
     setSubTitleFontColor(prev => ({
      ...prev,
      [key]:item?.contents[currentContentIndex-1]?.subTitleFontColor
    }));
    setTitleFontWeight(prev => ({
      ...prev,
      [key]:item?.contents[currentContentIndex-1]?.titleFontWeight
    }));
   setSubTitleFontWeight(prev => ({
      ...prev,
      [key]:item?.contents[currentContentIndex-1]?.subTitleFontWeight
    }));
    setShowTitle(prev => ({
      ...prev,
      [key]:item?.contents[currentContentIndex-1]?.showTitle
    }));
     setShowSubTitle(prev => ({
      ...prev,
      [key]:item?.contents[currentContentIndex-1]?.showSubTitle
    }));
   setAspectRatio(prev => ({
      ...prev,
      [key]:item?.contents[currentContentIndex-1]?.aspectRatio
    }));
    setimarginLeft(prev => ({
      ...prev,
      [key]:item?.contents[currentContentIndex-1]?.imarginLeft
    }));
    setimarginTop(prev => ({
      ...prev,
      [key]:item?.contents[currentContentIndex-1]?.imarginTop
    }));
    setmarginLeft(prev => ({
      ...prev,
      [key]:item?.contents[currentContentIndex-1]?.marginLeft
    }));
     setmarginTop(prev => ({
      ...prev,
      [key]:item?.contents[currentContentIndex-1]?.marginTop
    }));  setmarginBottom(prev => ({
      ...prev,
      [key]:item?.contents[currentContentIndex-1]?.marginBottom
    }));
   setBorderRadius(prev => ({
      ...prev,
      [key]:item?.contents[currentContentIndex-1]?.borderRadius
    }));
    setFontFamily(prev => ({
      ...prev,
      [key]:item?.contents[currentContentIndex-1]?.fontFamily
    }));
     setLayoutSettings(prev => ({
      ...prev,
      [key]:item?.contents[currentContentIndex-1]?.layoutSettings
    }));
     setCards(prev => ({
      ...prev,
      [key]:item?.contents[currentContentIndex-1]?.itemCards
    }));
   setTextAlignment(prev => ({
      ...prev,
      [key]:item?.contents[currentContentIndex-1]?.textAlignment
    }));
   setItemBackground(prev => ({
      ...prev,
      [key]:item?.contents[currentContentIndex-1]?.itemBackground
    }));
   setiWidth(prev => ({
      ...prev,
      [key]:item?.contents[currentContentIndex-1]?.iWidth
    }));
    setTextPosition(prev => ({
      ...prev,
      [key]:item?.contents[currentContentIndex-1]?.textPosition
    }));
  setApplyOverlay(prev => ({
      ...prev,
      [key]:item?.contents[currentContentIndex-1]?.applyOverlay
    }));
  setOverlayTitleFontColor(prev => ({
      ...prev,
      [key]:item?.contents[currentContentIndex-1]?.overlayTitleFontColor
    }));
  setOverlayBG(prev => ({
      ...prev,
      [key]:item?.contents[currentContentIndex-1]?.overlayBG
    }));
   
  setItemVisibility(prev => ({
      ...prev,
      [key]:item?.contents[currentContentIndex-1]?.itemVisibility
    }));
   

  setAbsoluteHorizontal(prev => ({
      ...prev,
      [key]:item?.contents[currentContentIndex-1]?.absoluteHorizontal
    }));
  setAbsoluteHorizontalMargin(prev => ({
      ...prev,
      [key]:item?.contents[currentContentIndex-1]?.absoluteHorizontalMargin
    }));
  setAbsoluteVertical(prev => ({
      ...prev,
      [key]:item?.contents[currentContentIndex-1]?.absoluteVertical
    }));
  setAbsoluteVerticalMargin(prev => ({
      ...prev,
      [key]:item?.contents[currentContentIndex-1]?.absoluteVerticalMargin
    }));
   
}
 const functGetNewItem=(cardId)=>{
  let newItem={};
 
 newItem = sectionTheme1InfoCardObject(cardId);
 const timestamp = Date.now();
  newItem={...newItem,id:timestamp}
        //  if(extractElementType(dragIndex)=="list2"){ 
           
        // newItem = sectionTheme1InfoCardObject("Card2");
        
        // }

 
   
        return newItem;
 }
 
// let dropFlagk=dropFlag;
const handleDrop = (e, dropIndex,dropFlagk) => {
  // prevent duplicate 
  if(dropFlagk>1){return;}
  ;
  // setDropFlag(dropFlagk+1);
  e.preventDefault();
  e.stopPropagation()
  const dragIndex = e.dataTransfer.getData("dragIndex");
  
const isNullOrEmpty = (val) => {
  return val === null || val === undefined || val == '';
};

  if((isNullOrEmpty(dropIndex))) return;
  if((isNullOrEmpty(dragIndex))) return;

  if (dragIndex === dropIndex) return;
 
// set new Item As Per Item Type 
// alert(extractElementType(dragIndex))
let newItem = {}
let createItemStatus=false;
 if(extractElementType(dragIndex))
  { createItemStatus=true;
   newItem =   functGetNewItem(extractElementType(dragIndex));
   
  }  





  if(createItemStatus){
    // set dynamic keys for Duplicating Items
    duplicateItemKey(newItem,dragIndex);
setItemArrLoading(itemArrLoads)
    // this code is for reloading status for settings component
    setDynamicIdChange(false);setTimeout(()=>{
      setDynamicIdChange(true);setItemArrLoading([])
     
    },0);
   
  setItemArr((prev) => {
    
    let updatedArr = [...prev, newItem];
    
const updatedItems = [...updatedArr];

const indexOfSentItem = updatedItems?.findIndex(item => item?.myKey === dragIndex);

// if (indexOfSentItem !== -1) {
 if(true){

  const [draggedItem] = updatedItems?.splice(indexOfSentItem, 1);
 // Clone and update the key
const newDraggedItem = {
  ...draggedItem,
  myKey: `${draggedItem.myKey+generateTimestamp()}` ,
  contents: draggedItem?.contents.map((content, index) =>
    index === index
      ? { ...content, myKey:content?.myKey+generateTimestamp() + 2,
      }
      : content)
};

updatedItems.splice(dropIndex, 0, newDraggedItem);
}




  
setHideReduUnDo(true)
 setDynamicId(dragIndex);
    setCurrentContentObject(newItem);setItemArrLoading(itemArrLoads)
    setDynamicIdChange(false);setTimeout(()=>{
      setDynamicIdChange(true);setItemArrLoading([])
    const reordered = updatedItems.map((item, index) => ({
    id: item?.dbId,
    menuOrder: index+1
}));
  handleCreateNewSectionCMRest(newItem,dropFlagk,updatedItems?.length>1?dropIndex+1:1,reordered );


dropFlagk++;
    },100);
// setItemArr(updatedItems);
 updateSchema(updatedItems);

    return updatedItems;
  });

  setDraggedIndex('');
  setHoveredDropZone(null); // Reset hovered drop zone
}

};  

const handleDragOver = (e, index) => {
  e.preventDefault();
   // Set the hovered drop zone
};

const handleDragEnd = () => {
  setDraggedIndex('');
  setHoveredDropZone(null); // Clear hovered drop zone
};
const setCurrentObject=(id,item)=>{
  
     setDynamicId(id);
     setCurrentContentObject(item);
             
    setItemArrLoading(itemArrLoads);
    setDynamicIdChange(false);setTimeout(()=>{
      setDynamicIdChange(true);setItemArrLoading([])
      // alert(columnsList[id]);
    },0)
  
}
   
    return <div  className="websitePageXsMargin"  >
      {closePagePopUp?<CreateNewWebPage closePagePopUp={()=>{setClosePagePopUp(false)}} onClickCreate={(v)=>{ handleCreateNewPageCMRest(v)}} />:""}
       <div style={{position:"absolute",zIndex:"9999999999"}}> {fireConfetti && ( 
        <CustomCanvasConfetti AnimType="firework" />
        
      )} 
</div>
   
   <div  ref={bodyWidthForMobile}  >
 
   
 <div className="gridForAppMobileRight"  >

   
      <div className="gridFiftyFixed" style={{alignContent:"center",textAlign:"center",gap:"10px",width:"95%",margin:"10px",
   
   transition: 'transform 2s ease, opacity 1s ease',
 }}>        <PageDropDownMenuCard  hasDropDown={true}   dropDownObjectI={pageArr}  activeCard={false}  icon={6} title ="Page" createNewPage={()=>{setClosePagePopUp(true)}} onClickBackObject={(v)=>{setCurrentPage(v)}} onClickPopup={
   ()=>{openDesignContent(false);  setActiveCardDesign(false);;setActiveCardScreens(false);setActiveCardElements(true);;setActiveCardSettings(false);}} />
    <PageDropDownMenuCard  hasDropDown={false}   activeCard={false}  icon={9} title ="Elements" onClickPopup={
   ()=>{openDesignContent(false); setopenAppDesignPopUpInn(true); setActiveCardDesign(false);;setActiveCardScreens(false);setActiveCardElements(true);;setActiveCardSettings(false);}} />
   
            </div>  

  <div>
    <div className="gridForWebBuilderK3 hideXsForApp" style={{alignContent:"center",textAlign:"center",gap:"10px",
   
   transition: 'transform 2s ease, opacity 1s ease',width:!mainMenuStatus&&openAppDesignPopUpInn?"100%":mainMenuStatus&&!openAppDesignPopUpInn?"90%":mainMenuStatus&&openAppDesignPopUpInn?"55%":"100%",
 }}>  

          
           <PageDropDownMenuCard hasDropDown={false} activeCard={designContent}   icon={5} title ="Designs" onClickPopup={
   ()=>{ openDesignContent(true);setCardEditor(""); setopenAppDesignPopUpInn(false);setActiveCardDesign(false);;setActiveCardScreens(false);setActiveCardElements(false);;setActiveCardSettings(false); }} /> 
   
          {/* <PageDropDownMenuCard  hasDropDown={false} activeCard={activeCardElements}  icon={6} title ="Elements" onClickPopup={
   ()=>{openDesignContent(false);  setActiveCardDesign(false);;setActiveCardScreens(false);setActiveCardElements(true);;setActiveCardSettings(false);}} /> */}
    <PageDropDownMenuCard  hasDropDown={false}  activeCard={activeCardDesign}   icon={2} title ="Website" onClickPopup={
   ()=>{openDesignContent(false);setopenAppDesignPopUpInn(false);  setActiveCardDesign(true);;setActiveCardScreens(false);setActiveCardElements(false);;setActiveCardSettings(false); }} />
    {!hideReduUnDo?<div style={{ paddingTop:"10px" }}>
        <button className="classSettBtns" style={{background:canUndo?"rgba(144, 202, 249,1)":"#fff",color:!canUndo?"rgba(144, 202, 249,1)":"#fff",padding:"10px"}} onClick={()=>{undo();
         setDynamicIdChange(false); setItemArrLoading(itemArrLoads);setTimeout(() => { setDynamicIdChange(true);setItemArrLoading([])}, 0); 
        }}
         disabled={!canUndo}>↩ Undo</button>
        <button className="classSettBtns"  style={{background:canRedo?"rgba(144, 202, 249,1)":"#fff",color:!canRedo?"rgba(144, 202, 249,1)":"#fff",padding:"10px"}} onClick={()=>{redo();
           setDynamicIdChange(false);setItemArrLoading(itemArrLoads); setTimeout(() => { setDynamicIdChange(true);setItemArrLoading([])}, 0);
         }} disabled={!canRedo}>↪ Redo</button>
        {/* <button className="classSettBtns" style={{background:"rgba(86, 82, 131,0.7)",color:"#fff",border:"2px solid rgba(86, 82, 131,1)",padding:"10px"}}  onClick={()=>{reset();
           setDynamicIdChange(false); setItemArrLoading(itemArrLoads);setTimeout(() => { setDynamicIdChange(true);setItemArrLoading([])}, 0);
         }}>♻ Reset</button> */}
       
      </div>:""}
       {!hideReduUnDo?<div style={{ paddingTop:"10px" }}>
        <button className="classSettBtns" style={{background:"rgba(7, 7, 7, 0.94)",color:"#fff",border:"2px solid rgb(12, 12, 12)",padding:"10px"}}onClick={()=>{
           
         }}>Save</button>
         <button className="classSettBtns" style={{background:"rgba(86, 82, 131,0.7)",color:"#fff",border:"2px solid rgba(86, 82, 131,1)",padding:"10px"}} onClick={()=>{
         }}>Preview</button>
      </div>:""}
     {/* <PageDropDownMenuCard hasDropDown={false} activeCard={activeCardScreens}   icon={4} title ="Screens" onClickPopup={
   ()=>{openDesignContent(false);  setActiveCardDesign(false);;setActiveCardScreens(true);setActiveCardElements(false);;setActiveCardSettings(false); }} /> */}
   
   
   </div>
   
   
</div>
<div  className="fix-menu-theme-right-app" style={fixMenuAppRightHide}>  
<AppMenuCard  activeCard={{}}  icon={9} title ="open" onClickPopup={
          ()=>{closeFixMenuAppRight(false);  }} /></div>
<div  className="fix-menu-theme-right-app" style={fixMenuAppRightShow}>  
<AppMenuCard  activeCard={{}}  icon={8} title ="close" onClickPopup={
          ()=>{closeFixMenuAppRight(true);  }} />
          <AppMenuCard  activeCard={activeCardElements}  icon={6} title ="Elements" onClickPopup={
          ()=>{openDesignContent(false);setopenAppDesignPopUpInn(true);  setActiveCardDesign(false);;setActiveCardScreens(false);setActiveCardElements(true);;setActiveCardSettings(false);  }} />
 
<AppMenuCard  activeCard={activeCardDesign}  icon={2} title ="Website " onClickPopup={
          ()=>{openDesignContent(false); setopenAppDesignPopUpInn(false); setActiveCardDesign(true);;setActiveCardScreens(false);setActiveCardElements(false);;setActiveCardSettings(false);   }} />
  <AppMenuCard  activeCard={designContent}  icon={5} title ="Designs" onClickPopup={
          ()=>{setCardEditor(""); setopenAppDesignPopUpInn(false);openDesignContent(true);setActiveCardDesign(false);;setActiveCardScreens(false);setActiveCardElements(false);;setActiveCardSettings(false);  }} />
<AppMenuCard  activeCard={activeCardScreens}  icon={4} title ="Pages" onClickPopup={
          ()=>{openDesignContent(false);  setActiveCardDesign(false);;setActiveCardScreens(true);setActiveCardElements(false);;setActiveCardSettings(false);    }} />
          {/* <AppMenuCard  activeCard={activeCardElements}  icon={6} title ="Themes" onClickPopup={
          ()=>{openDesignContent(false);setActiveCardDesign(false);;setActiveCardScreens(false);setActiveCardElements(true);;setActiveCardSettings(false);  }} /> */}
 <AppMenuCard  activeCard={activeCardSettings}  icon={7} title ="Settings" onClickPopup={
          ()=>{openDesignContent(false);  setActiveCardDesign(false);;setActiveCardScreens(false);setActiveCardElements(false);;setActiveCardSettings(true);  }} />
   </div>

      </div>
      
  
        <div  className="hideFlexStylesXs" style={{paddingLeft:"10px",paddingRight:"10px",display:"flex",justifyContent:"flex-start",alignItems:"center",gap:"10px"}} >

   {openAppDesignPopUpInn?<div align="center" className="fullWidthXS" style={{position:"relative",padding:"5px",top:!mainMenuStatus&&openAppDesignPopUpInn?"10px":"10px",border:"3px solid #ffffff",borderRadius:"15px", 
    width:!mainMenuStatus&&openAppDesignPopUpInn?"25vw":mainMenuStatus&&!openAppDesignPopUpInn?"0vw":mainMenuStatus&&openAppDesignPopUpInn?"25vw":"0vw",
    marginTop:mainMenuStatus&&openAppDesignPopUpInn?"-22vh":"",}}>
  <button onMouseEnter={handleMouseEnter}
  onMouseLeave={handleMouseLeave} onClick={()=>{setopenAppDesignPopUpInn(false);
    setCurrentObject("",{});
  }} style={{position:"absolute",border:"4px solid #fff",top:"-55px",right:"-15px",background:"rgba(144, 202, 249,1)",color:"#fff",width:"35px",cursor:"pointer",zIndex:99999,height:"35px"}} 
  className=" CoursesPreviewTopBtn"  type="submit"
 > <X size={18} color={"#fff"}style={{marginTop:"-5px"}}/></button>
 {/* {!hideReduUnDo?<div style={{ marginBottom: 12 }}>
        <button className="classSettBtns" style={{background:canUndo?"rgba(144, 202, 249,1)":"#fff",color:!canUndo?"rgba(144, 202, 249,1)":"#fff"}} onClick={()=>{undo();
         setDynamicIdChange(false); setItemArrLoading(itemArrLoads);setTimeout(() => { setDynamicIdChange(true);setItemArrLoading([])}, 0); 
        }}
         disabled={!canUndo}>↩ Undo</button>
        <button className="classSettBtns"  style={{background:canRedo?"rgba(144, 202, 249,1)":"#fff",color:!canRedo?"rgba(144, 202, 249,1)":"#fff"}} onClick={()=>{redo();
           setDynamicIdChange(false);setItemArrLoading(itemArrLoads); setTimeout(() => { setDynamicIdChange(true);setItemArrLoading([])}, 0);
         }} disabled={!canRedo}>↪ Redo</button>
        <button className="classSettBtns" style={{background:"rgba(86, 82, 131,0.7)",color:"#fff",border:"2px solid rgba(86, 82, 131,1)"}}  onClick={()=>{reset();
           setDynamicIdChange(false); setItemArrLoading(itemArrLoads);setTimeout(() => { setDynamicIdChange(true);setItemArrLoading([])}, 0);
         }}>♻ Reset</button>
         <button className="classSettBtns" style={{background:"rgba(7, 7, 7, 0.94)",color:"#fff",border:"2px solid rgb(12, 12, 12)"}}onClick={()=>{
           
         }}>Save</button>
         <button className="classSettBtns" style={{background:"rgba(86, 82, 131,0.7)",color:"#fff",border:"2px solid rgba(86, 82, 131,1)"}} onClick={()=>{
         }}>Preview</button>
      </div>:""} */}
       {activeCardElements?
 <><div style={{color:"#444444",borderRadius:"15px",fontSize:"19px",fontWeight:"bold",padding:"8px",paddingTop:"10px",margin:"5px"}}>
       Elements</div>           
<div className="appShowElementsScroller" >
 {
 // Showing Draggable Cards Per Theme  DragCards[0]
 }
  {DragCards[0]?.Cards?.map((item,index)=>(
<> <div style={{background:"#ffffff",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0401)",borderRadius:"15px",marginBottom:"20px",paddingBottom:"20px"}}
      onMouseEnter={
                      ()=>handleMouseEnter("#ffffff ","#222 ","Double-click to select, then drag it near Website and drop it.")}
      onMouseLeave={handleMouseLeave}>  
                           
                          <div draggable  onDragStart={(e) =>{ handleDragStart(e, `id-${item?.card}-${itemArr?.length+1}`);
              setDraggedIndex(`id-${item?.card}-${itemArr?.length+1}`);setSelectedItemIndex(`id-${item?.card}-${itemArr?.length+1}`);
             }}
             style={{ cursor: 'move', }}  
           onDrop={(e) => {
            handleDrop(e, `id-${item?.card}-${itemArr?.length+1}`,1);
           setSelectedItemIndex(null);}} onDragEnd={handleDragEnd}
            > <div style={{display:"flex",justifyContent:"left", color:"#444444",borderRadius:"15px",fontSize:"19px",fontWeight:"bold",padding:"8px",paddingTop:"10px",margin:"5px"}}>
        {item?.card}</div> 
              <img src={`${imageMap[item.src]}`} style={
             {width:"90%" }} />
             
     </div>   
               </div></>
  ))}
     
               
      
    
    
    </div> </>:""}
    
     {activeCardDesign?
 reloadItems?currentSchema?.filter((item, index) => 
    item?.contents?.[currentContentIndex - 1]?.myKey === dynamicId &&
    currentItemIndex === index
  )?.map((item,index) => ((
   <div  index={index} key={item?.contents[currentContentIndex-1]?.id} >
    {/* item-{currentItemIndex} content- {currentContentIndex}  dynamicId-{dynamicId} currentItemId={currentContentObject?.myKey} contentId-{item?.contents[currentContentIndex-1]?.myKey} */}
   {/* {currentItemIndex==index&&dynamicId==item?.contents[currentContentIndex-1]?.myKey? */}
   <div> 

{/* {currentContentIndex-1} */}
    <WebUISettings 
   setCloseVariationPopUp={(v)=>{setCloseVariationPopUp(v)}}
    blockType={item?.contents[currentContentIndex-1]?.blockType}
     currentContentIndex={currentContentIndex-1}
          //  updateSchema={(value)=>updatedItems(value)}
  setItemArr={(val)=>{ setItemArr(val)   ;}}
  setItemArrCurrent={(val)=>{
    // updates redo , undo schema in history 
  //  console.log(val) ;
    updateSchema(val) ;setHideReduUnDo(false);handleUpdateSectionSchemaCMRest(val[currentItemIndex]?.dbId,val[currentItemIndex])
    
  }}
   sendBackImages={(val)=>{ updateImagesData(val)}}
  cards={item?.contents[currentContentIndex-1]?.itemCards?.cards} dynamicId={dynamicId}
  setCards={(val)=>{setCards(prev => ({...prev,[dynamicId]: {cards:val}})); updateImagesData(val);
 }}
  scrollItems={item?.contents[currentContentIndex-1]?.scrollItems} setScrollItems={(val)=>{ setScrollItems(prev => ({...prev, [dynamicId]: val})); }}
  columnsList={item?.contents[currentContentIndex-1]?.columns} setColumnsList={(val)=>{ setColumnsList(prev => ({...prev,[dynamicId]: val}));
 
  } } 
  fontFamily={item?.contents[currentContentIndex-1]?.fontFamily} setFontFamily={(val)=>{setFontFamily(prev => ({...prev,[dynamicId]: val}));  }}
  layoutSettings={item?.contents[currentContentIndex-1]?.layoutSettings}
   setLayoutSettings={(val)=>{setLayoutSettings(prev => ({...prev,[dynamicId]: val}));  }}
   fontWeight={item?.contents[currentContentIndex-1]?.fontWeight} setFontWeight={(val)=>{ setFontWeight(prev => ({ ...prev, [dynamicId]: val  }));}}
    iWidth={item?.contents[currentContentIndex-1]?.iWidth} setiWidth={(val)=>{setiWidth(prev => ({ ...prev, [dynamicId]: val  }));}} 
    iHeight={item?.contents[currentContentIndex-1]?.iHeight} setiHeight={(val)=>{setiHeight(prev => ({ ...prev, [dynamicId]: val  }));}}
         titleFontSize={item?.contents[currentContentIndex-1]?.titleFontSize} setTitleFontSize={(val)=>{setTitleFontSize(prev => ({ ...prev, [dynamicId]: val  }));}} 
    subTitleFontSize={item?.contents[currentContentIndex-1]?.subTitleFontSize} setSubTitleFontSize={(val)=>{setSubTitleFontSize(prev => ({ ...prev, [dynamicId]: val  }));}}
    titleFontColor={item?.contents[currentContentIndex-1]?.titleFontColor} setTitleFontColor={(val)=>{setTitleFontColor(prev => ({ ...prev, [dynamicId]: val  }));}} 
    subTitleFontColor={item?.contents[currentContentIndex-1]?.subTitleFontColor} setSubTitleFontColor={(val)=>{setSubTitleFontColor(prev => ({ ...prev, [dynamicId]: val  }));}}
      titleFontWeight={item?.contents[currentContentIndex-1]?.titleFontWeight} setTitleFontWeight={(val)=>{setTitleFontWeight(prev => ({ ...prev, [dynamicId]: val  }));}} 
    subTitleFontWeight={item?.contents[currentContentIndex-1]?.subTitleFontWeight} setSubTitleFontWeight={(val)=>{setSubTitleFontWeight(prev => ({ ...prev, [dynamicId]: val  }));}}  
  
    borderRadius={item?.contents[currentContentIndex-1]?.borderRadius}setBorderRadius={(val)=>{setBorderRadius(prev => ({ ...prev, [dynamicId]: val  }));}}
     marginLeft={item?.contents[currentContentIndex-1]?.marginLeft} setmarginLeft={(val)=>{setmarginLeft(prev => ({ ...prev, [dynamicId]: val  }));}}
    marginTop={item?.contents[currentContentIndex-1]?.marginTop} setmarginTop={(val)=>{setmarginTop(prev => ({ ...prev, [dynamicId]: val  }));}} 
    marginBottom={item?.contents[currentContentIndex-1]?.marginBottom} setmarginBottom={(val)=>{setmarginBottom(prev => ({ ...prev, [dynamicId]: val  }));}} 
    imarginLeft={item?.contents[currentContentIndex-1]?.imarginLeft} setimarginLeft={(val)=>{setimarginLeft(prev => ({ ...prev, [dynamicId]: val  }));}}
    imarginTop={item?.contents[currentContentIndex-1]?.imarginTop} setimarginTop={(val)=>{setimarginTop(prev => ({ ...prev, [dynamicId]: val  }));}}
    aspectRatio={item?.contents[currentContentIndex-1]?.aspectRatio} setAspectRatio={(val)=>{setAspectRatio(prev => ({ ...prev, [dynamicId]: val  }));}}
    showTitle={ item?.contents[currentContentIndex-1]?.showTitle} setShowTitle={(val)=>{setShowTitle(prev => ({ ...prev, [dynamicId]: val  }));}}
   showSubTitle={ item?.contents[currentContentIndex-1]?.showSubTitle} setShowSubTitle={(val)=>{setShowSubTitle(prev => ({ ...prev, [dynamicId]: val  }));}}
    textAlignment={item?.contents[currentContentIndex-1]?.textAlignment} setTextAlignment={(val)=>{ setTextAlignment(prev => ({ ...prev, [dynamicId]: val  }));}}

     textPosition={item?.contents[currentContentIndex-1]?.textPosition} setTextPosition={(val)=>{ setTextPosition(prev => ({ ...prev, [dynamicId]: val  }));}}
   applyOverlay={item?.contents[currentContentIndex-1]?.applyOverlay} setApplyOverlay={(val)=>{ setApplyOverlay(prev => ({ ...prev, [dynamicId]: val  }));}}
   overlayTitleFontColor={item?.contents[currentContentIndex-1]?.overlayTitleFontColor} setOverlayTitleFontColor={(val)=>{ setOverlayTitleFontColor(prev => ({ ...prev, [dynamicId]: val  }));}}
   overlayBG={item?.contents[currentContentIndex-1]?.overlayBG} setOverlayBG={(val)=>{ setOverlayBG(prev => ({ ...prev, [dynamicId]: val  }));}}
absoluteHorizontal={item?.contents[currentContentIndex-1]?.absoluteHorizontal} setAbsoluteHorizontal={(val)=>{ setAbsoluteHorizontal(prev => ({ ...prev, [dynamicId]: val  }));}}
absoluteHorizontalMargin={item?.contents[currentContentIndex-1]?.absoluteHorizontalMargin} setAbsoluteHorizontalMargin={(val)=>{ setAbsoluteHorizontalMargin(prev => ({ ...prev, [dynamicId]: val  }));}}
absoluteVertical={item?.contents[currentContentIndex-1]?.absoluteVertical} setAbsoluteVertical={(val)=>{ setAbsoluteVertical(prev => ({ ...prev, [dynamicId]: val  }));}}
absoluteVerticalMargin={item?.contents[currentContentIndex-1]?.absoluteVerticalMargin} setAbsoluteVerticalMargin={(val)=>{ setAbsoluteVerticalMargin(prev => ({ ...prev, [dynamicId]: val  }));}}
itemVisibility={item?.contents[currentContentIndex-1]?.itemVisibility} setItemVisibility={(val)=>{ setItemVisibility(prev => ({ ...prev, [dynamicId]: val  }));}}

    itemBackground={item?.contents[currentContentIndex-1]?.itemBackground} setItemBackground={(val)=>{ updateItemBackground(val);}}
    />

   
    </div>
</div>))):<ListUISettingsLoading/>:""}

  
 {/* { flattenedDataLoading?.map((item, index) =>  */}
         {/* (<div  index={index} key={index}  > */}
{/* <ListUISettingsLoading/> */}
{/*             
<div  className="chapterContentItemGridOuter" style={{margin:"10px",minHeight:"40px",marginTop:"10px",paddingLeft:"10px",background:"#ffffff"}}>
         <div className="text-linetw "  style={{marginTop:"5px",marginRight:"10px",height:"17px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
    </div> <div className="text-linetw "  style={{marginTop:"5px",marginRight:"10px",height:"17px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
   </div><div  className="text-linetw" style={{marginTop:"5px",height:"17px",width:"94%",paddingLeft:"10px",padding:"5px"}}>
</div><div  className="courseContentItemOuterHeadActiveSettingsInn"
   style={{fontSize:"10px",color:"#222",fontWeight:"800"}}>
     <div className="text-linetw "  style={{marginTop:"5px",marginRight:"10px",height:"17px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
    </div> <div className="text-linetw "  style={{marginTop:"5px",marginRight:"10px",height:"17px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
    </div>  <div className="text-linetw "  style={{marginTop:"5px",marginRight:"10px",height:"17px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
    </div><div className="text-linetw "  style={{marginTop:"5px",marginRight:"10px",height:"17px",width:"54%",paddingLeft:"10px",padding:"5px"}}>
    
    </div></div>
     </div> */}
     
       {/* </div>))} */}
        {/* {!dynamicId?"You Have Not Selected Any Element For Edit":""} */}
</div>:""}

   {/* <div className=" browser-container-cmouter browserFrameScroller fullWidthVwXS"   style={{ position:"relative",left:openAppDesignPopUpInn?"0%":"", width:!mainMenuStatus&&openAppDesignPopUpInn?"61vw":mainMenuStatus&&!openAppDesignPopUpInn?"77vw":mainMenuStatus&&openAppDesignPopUpInn?"54vw":"86vw",marginTop:"-20px"}}> */}
   
    <div>{ !mainMenuStatus&&!openAppDesignPopUpInn?"":<div className="gridForWhatsNextAfterYT3" style={{alignContent:"center",textAlign:"center",gap:"10px",width:"50%", display:"flex",
    justifyContent:"center",transform:!mainMenuStatus&&openAppDesignPopUpInn?"scale(0.9) translate(-20%)":mainMenuStatus&&!openAppDesignPopUpInn?"scale(0.7) translate(-20%)":mainMenuStatus&&openAppDesignPopUpInn?"scale(0.9) translate(-20%)":"scale(0.7) translate(-20%)",
   
   transition: 'transform 2s ease, opacity 1s ease', position:!mainMenuStatus&&openAppDesignPopUpInn?"absolute":mainMenuStatus&&!openAppDesignPopUpInn?"absolute":mainMenuStatus&&openAppDesignPopUpInn?"absolute":"relative",
   left:!mainMenuStatus&&openAppDesignPopUpInn?"45vw":mainMenuStatus&&!openAppDesignPopUpInn?"35vw":mainMenuStatus&&openAppDesignPopUpInn?"45vw":"0vw",top:!mainMenuStatus&&openAppDesignPopUpInn?"125px":mainMenuStatus&&!openAppDesignPopUpInn?"90px":mainMenuStatus&&openAppDesignPopUpInn?"125px":"0vw",marginTop:"-20px"}}>  

          
           <PageDropDownMenuCard hasDropDown={false} activeCard={designContent}   icon={5} title ="Laptop View" onClickPopup={
   ()=>{  }} /> 
   
          {/* <PageDropDownMenuCard  hasDropDown={false} activeCard={activeCardElements}  icon={6} title ="Elements" onClickPopup={
   ()=>{openDesignContent(false);  setActiveCardDesign(false);;setActiveCardScreens(false);setActiveCardElements(true);;setActiveCardSettings(false);}} /> */}
    <PageDropDownMenuCard  hasDropDown={false}  activeCard={activeCardDesign}   icon={2} title ="Mobile View" onClickPopup={
   ()=>{ }} />
    
     <PageDropDownMenuCard  hasDropDown={false}  activeCard={activeCardDesign}   icon={2} title ="Tablet View" onClickPopup={
   ()=>{ }} />
    
      
     {/* <PageDropDownMenuCard hasDropDown={false} activeCard={activeCardScreens}   icon={4} title ="Screens" onClickPopup={
   ()=>{openDesignContent(false);  setActiveCardDesign(false);;setActiveCardScreens(true);setActiveCardElements(false);;setActiveCardSettings(false); }} /> */}
   
   
   </div>
}
   <div className=" browser-container-cmouter  "   style={{transform:!mainMenuStatus&&openAppDesignPopUpInn?"scale(0.67) translate(-23%)":mainMenuStatus&&!openAppDesignPopUpInn?"scale(0.88) translateX(-6%)  translateY(3%)":mainMenuStatus&&openAppDesignPopUpInn?"scale(0.57) translate(-38%)":"scale(1)", position:!mainMenuStatus&&openAppDesignPopUpInn?"absolute":"relative",left:!mainMenuStatus&&openAppDesignPopUpInn?"35vw":"0vw",top:!mainMenuStatus&&openAppDesignPopUpInn?"105px":"0vw", 
    width:!mainMenuStatus&&openAppDesignPopUpInn?"86vw":mainMenuStatus&&!openAppDesignPopUpInn?"86vw":mainMenuStatus&&openAppDesignPopUpInn?"86vw":"86vw",
      marginTop:"-20px",marginTop:!mainMenuStatus&&openAppDesignPopUpInn?"-10vh":mainMenuStatus&&openAppDesignPopUpInn?"-15vh":"",}}>
   <style>{ `
     body{overflow-y:${!mainMenuStatus&&!openAppDesignPopUpInn?"hidden":mainMenuStatus&&!openAppDesignPopUpInn?"hidden":mainMenuStatus&&openAppDesignPopUpInn?"hidden":""}}
    
       /* sm */
@media (min-width: 768px) and (max-width: 991px) {
 .browser-container-cmouter{position:relative !important;left:0px !important;transform:scale(1) translate(0px) !important; width:100vw !important;}
  body{overflow-x:${!mainMenuStatus&&openAppDesignPopUpInn?"hidden":mainMenuStatus&&!openAppDesignPopUpInn?"hidden":mainMenuStatus&&openAppDesignPopUpInn?"hidden":""}}
      }
    /* md */
   @media (min-width: 992px) and (max-width: 1199px) {
    .browser-container-cmouter{position:relative !important;left:0px !important;transform:scale(1) translate(0px) !important; width:100vw !important;}
   }
/* xs */
@media (max-width: 767px) { .browser-container-cmouter{position:relative !important;left:0px !important;transform:scale(1) translate(0px) !important; width:100vw !important;} }

        body{overflow-x:${!mainMenuStatus&&openAppDesignPopUpInn?"hidden":mainMenuStatus&&!openAppDesignPopUpInn?"hidden":mainMenuStatus&&openAppDesignPopUpInn?"hidden":""}}
       `}</style>
  
  
   <div className="browser-container-cm " >
      <div className="browser-frame">
        {/* Top bar */}
        <div className="browser-top-bar">
          <div className="window-controls">
            <span className="control red"></span>
            <span className="control yellow"></span>
            <span className="control green"></span>
          </div>
          <div className="address-bar">www.yourwebsite.com/{currentPage?.pageRouteSlug}</div>
          <div className="right-space"></div>
        </div>

        {/* Iframe */}
       

<div  style={{paddingBottom: "30px",paddingTop: "60px", 
height:!mainMenuStatus&&openAppDesignPopUpInn?"90vh":mainMenuStatus&&openAppDesignPopUpInn?"100vh":"",
 
 }} className="browserFrameScroller" id="scrollContainerId">
         {activeCardDesign?<>
  
   
   </>:designContent?<>
      {cardEditor=="leadForm"?
<LeadFormBuilder />:cardEditor=="courseCard"?<CourseCardBuilder />:cardEditor=="playerCard"?<PlayerCardBuilder />
  :cardEditor=="coursePageCard"?<CoursePageCardBuilder />:cardEditor=="mockTestCard"?<MockTestBuilder />:cardEditor=="dashboard"?<DashboardBuilder />:
  
<div className="">
<div className="gridForShowTwoSubCourses" >
   
 <ItemCardAppDesign icon={1} setEvent={()=>{setCardEditor("courseCard")}}  title=" Course Card Designer "/>
 <ItemCardAppDesign icon={2} setEvent={()=>{setCardEditor("playerCard")}}  title=" Player  Designer  "/>
 <ItemCardAppDesign icon={2} setEvent={()=>{setCardEditor("coursePageCard")}}  title=" Course Page  Designer  "/>
 <ItemCardAppDesign icon={2} setEvent={()=>{setCardEditor("mockTestCard")}}  title=" Mock Test Page  Designer  "/>
 <ItemCardAppDesign icon={2} setEvent={()=>{setCardEditor("dashboard")}}  title=" Dashboard Page  Designer  "/>

 {/* <ItemCardAppDesign icon={2} setEvent={()=>{setCardEditor("playerCard")}}  title=" Login/Signup  Designer  "/> */}
 {/* <ItemCardAppDesign icon={2} setEvent={()=>{setCardEditor("playerCard")}}  title=" Filter Page  Designer  "/> */}
 {/* <ItemCardAppDesign icon={2} setEvent={()=>{setCardEditor("playerCard")}}  title=" Navbar  Designer  "/> */}
 {/* <ItemCardAppDesign icon={2} setEvent={()=>{setCardEditor("playerCard")}}  title=" Footer Card  Designer  "/> */}
 {/* <ItemCardAppDesign icon={2} setEvent={()=>{setCardEditor("leadForm")}}  title=" Lead Form  Designer  "/> */}
     </div></div>}
{/* <CoursePageBuilder /> */}
      </>
      :activeCardScreens?"Screens"
      :""}
      {
        activeCardDesign||activeCardElements?<>
       {
      
  itemArr?.length!=0?<>{ currentSchema?.length!=0?"":""}{currentSchema?.map((item,index) => ((
      
  <div  index={index} key={item?.id}   style={{ background:item?.itemBackground?.color,
    // borderTop:dynamicId==item?.contents[currentContentIndex-1]?.myKey?"2px solid rgba(144, 202, 249,1)":"2px solid transparent",
    borderBottom:dynamicId==item?.contents[currentContentIndex-1]?.myKey?"2px solid rgba(144, 202, 249,1)":"2px solid transparent"
  }}
          >
    
            <div
       
onDragOver={(e) => { if(selectedItemIndex!==index){
  setHoveredDropZone(index);
    // handleDragOver(e, index)
  }
  }}
  onDrop={(e) => {setSelectedItemIndex(null);setHoveredDropZone(null);}}

             onDragStart={(e) =>{
              //  handleDragStart(e, index);
              setDraggedIndex(item.id);setSelectedItemIndex(index);
             }}
             style={{
              cursor: 'pointer',
             
              
            }}  
              // onDragEnd={handleDragEnd}
onDragEnd={(e) =>{setSelectedItemIndex(null);setHoveredDropZone(null);}}
        


              
            >
            
      <div onClick={()=>{
      }} > 
                
        

      <UIWebBlockRenderer setCurrentContentIndex={(currentContentIndex)=>{setCurrentItemIndex(index);setCurrentContentIndex(currentContentIndex);
      setopenAppDesignPopUpInn(true);setActiveCardDesign(true); setReloadItems(false);setTimeout(()=>{ setReloadItems(true);},300)
       setActiveCardElements(false);;}}
         moveItemUp={(item)=>{moveItemUp(item);setHideReduUnDo(true);
          setActiveCardDesign(false);
       setActiveCardElements(true);;
         }}
          moveItemDown={(item)=>{moveItemDown(item);setHideReduUnDo(true);
            setActiveCardDesign(false);
       setActiveCardElements(true);;
          }} 
      deleteItem={(item)=>{deleteItem(item);setHideReduUnDo(true);
        setActiveCardDesign(false);
       setActiveCardElements(true);;
      }} 
      duplicateItem={(item)=>{duplicateItem(item);setHideReduUnDo(true);
       setActiveCardDesign(false);
       setActiveCardElements(true);;
      }} 
      duplicateContentsItem={(item)=>{ duplicateContentsItem(item);setHideReduUnDo(true)}} 
      currentIndex={currentIndex}
      item={item} dynamicId={dynamicId} 
             setCurrentObject={(currentContentObjectKey,currentContentObject)=>{setCurrentObject(currentContentObjectKey,currentContentObject);}}
            
           />


       
          </div>
                <div
          className="drop-zone"
          onDragOver={(e) => { e.preventDefault()
            handleDragOver(e, index+1) // index+1 for add  below item
          }}
          onDrop={(e) =>{ setDropFlag(1); handleDrop(e, index+1,1);setSelectedItemIndex(null);setHoveredDropZone(null);}}
        
          style={{
            height: hoveredDropZone === index ?'50px':"0px",position:hoveredDropZone === index ?'relative':"",left:"10px",right:"10px",bottom:"10px",
            backgroundColor: hoveredDropZone === index ? '#ffffff ' : 'transparent', // Change color on hover
            border: hoveredDropZone === index ? '2px dashed rgba(144, 202, 249,1) ' : 'transparent', // Change color on hover
            transition: 'background-color  0.3s ease',width:"90%",
            borderRadius: '10px',marginBottom:hoveredDropZone === index ?"0px":"0px",display:"flex",justifyContent:"center",
           visibility:hoveredDropZone === index ?"visible":"hidden",fontSize:"14px",
          }}
        >
          <div style={{paddingTop:"15px",height:"100px"}}>Drop Element Here</div></div>
        
          </div>
          </div>
     ))
     )}</>
     :<><div
          className="drop-zone"
          onDragOver={(e) => { e.preventDefault()
            handleDragOver(e, 1) // index+1 for add  below item
          }}
          onDrop={(e) =>{setDropFlag(1); handleDrop(e, 1,1);setSelectedItemIndex(null);setHoveredDropZone(null);}}
        
          style={{
            height: '50px',position:'relative',left:"10px",right:"10px",bottom:"10px",
            backgroundColor: '#ffffff ' ,
            border:  '2px dashed rgba(144, 202, 249,1) ' ,
            transition: 'background-color  0.3s ease',width:"98%",
            borderRadius: '10px',display:"flex",justifyContent:"center",
          fontSize:"18px",fontWeight:"999"
          }}
        >
          <div style={{paddingTop:"15px",height:"100px"}}>Drop Element Here</div></div>
        
        
        <div className={"showPlusElementOuter" }
          onClick={
   ()=>{openDesignContent(false); setopenAppDesignPopUpInn(true); setActiveCardDesign(false);;setActiveCardScreens(false);setActiveCardElements(true);;setActiveCardSettings(false);}}
        style={{transform:"scale(2)",
            height: '50px',position:'relative',left:"10px",right:"10px",bottom:"10px",
          
            transition: 'background-color  0.3s ease',width:"98%",
            borderRadius: '10px',display:"flex",justifyContent:"center",
          fontSize:"18px",fontWeight:"999"
          }} > <div className="showPlusElement"  onMouseEnter={
                                ()=>handleMouseEnter("","","")}
                onMouseLeave={handleMouseLeave} style={{}}><div style={{ position:"relative",padding:"5px",marginTop:"19px",width:"25px",height:"25px",borderRadius:"50%",background:"rgba(144, 202, 249,0.41)"}} ><Plus size={23} style={{width:"25px",height:"25px",borderRadius:"50%",background:"rgba(144, 202, 249,0.941)"}} color="#ffffff" /></div></div></div>
          
</>}
      </>:activeCardSettings?" Settings"  
      :""}  
  
</div>

      </div>
      </div>
    </div></div>

        </div>

      <div style={{padding:"10px",}} ref={bottomDivBoxRef}></div>

 
{/* <div  style={{height:"580px"}}></div> */}
</div><div>
      </div>
 {closeVariationPopUp?<VariationSectionTemplates currentSectionSchema={currentSchema[currentItemIndex]} setCloseVariationPopUp ={()=>{setCloseVariationPopUp(false)}}  />:""}
                            
        


    
<style>{`#hideMenuBar{display:none !important}`}</style>
    </div>

}
export default WebsiteSettings;
